export const state = {
  complectations: [],
  complectation: null,
  sale_price: null,
  price: null,
  credits: window.credit,
}
